import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import Loader from "./components/Loader";
import CustomCursor from "./components/CustomCursor";
import ScrollProgress from "./components/ScrollProgress";
import Particles from "./components/Particles";
import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import TalentPage from "./pages/TalentPage";
import ContactPage from "./pages/ContactPage";

// Page transition wrapper
const PageTransition = ({ children }) => {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.4 }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function AppContent() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<PageTransition><HomePage /></PageTransition>} />
          <Route path="/nosotros" element={<PageTransition><AboutPage /></PageTransition>} />
          <Route path="/about" element={<PageTransition><AboutPage /></PageTransition>} />
          <Route path="/servicios" element={<PageTransition><ServicesPage /></PageTransition>} />
          <Route path="/services" element={<PageTransition><ServicesPage /></PageTransition>} />
          <Route path="/talento" element={<PageTransition><TalentPage /></PageTransition>} />
          <Route path="/talent" element={<PageTransition><TalentPage /></PageTransition>} />
          <Route path="/contacto" element={<PageTransition><ContactPage /></PageTransition>} />
          <Route path="/contact" element={<PageTransition><ContactPage /></PageTransition>} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
    if (isLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isLoading]);

  return (
    <LanguageProvider>
      <BrowserRouter>
        {/* Loading Screen */}
        <AnimatePresence>
          {isLoading && (
            <Loader onComplete={() => setIsLoading(false)} />
          )}
        </AnimatePresence>

        {/* Main App */}
        {!isLoading && (
          <>
            <CustomCursor />
            <ScrollProgress />
            <Particles />
            <div className="App min-h-screen bg-[#050505] relative z-10" data-testid="app-container">
              <AppContent />
            </div>
          </>
        )}
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
